<template>
  <base-modal ref="restoreModal" header-disable footer-disable>
    <template v-slot:body>
      <div class="samo samo-site">
        <form class="login-form" @submit.prevent="restorePassword">
          <div class="form-header">
            <h1>{{ $t('app.modals.restore_password.title') }}</h1>
          </div>
          <div class="form-group">
            <label class="control-label samo-label" for="restoreEmail">{{
                getTranslateSpace($t('app.modals.restore_password.email_label')) }}</label>
            <input id="restoreEmail" v-model="restoreEmail" class="samo-input form-control"
                   :class="{ 'is-invalid': v$.restoreEmail.$error }" type="email">
            <small class="error-message" v-if="v$.restoreEmail.$error">{{
                $t(...getTranslateParams(v$.restoreEmail.$errors[0].$message)) }}</small>
          </div>
          <div class="form-group">
            <button class="btn btn-primary text-white" type="submit">
              {{ $t('app.restore_password') }}
            </button>
          </div>
          <div class="form-group text-center">
            <a class="btn-link" href="#" @click="openLogin">{{ $t('app.login') }}</a>
          </div>
          <div v-if="infoMessage" class="mt-4 p-3 info-message row g-0">
            {{ infoMessage }}
          </div>
          <div class="error mt-4 p-3" v-if="error">
            {{ error }}
          </div>
        </form>
      </div>
    </template>
  </base-modal>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'
import BaseModal from 'components/ui/BaseModal.vue'
import translateMixin from 'mixins/translate'

export default {
  name: "RestoreModal",
  components: { BaseModal },
  mixins: [translateMixin],
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      restoreEmail: '',
      isLoading: false,
      error: null,
      infoMessage: null
    }
  },
  validations: {
    restoreEmail: { required, email }
  },
  methods: {
    open() {
      this.$refs.restoreModal.open();
      this.resetMessages();
    },
    async restorePassword() {
      this.v$.restoreEmail.$touch();
      this.resetMessages();
      if (!this.v$.restoreEmail.$invalid) {
        this.isLoading = true;
        try {
          await this.$store.dispatch('users/restorePassword', this.restoreEmail);
          this.infoMessage = this.$t('app.modals.restore_password.success_message');
        } catch (error) {
          this.error = error.data.message || this.$t('app.modals.restore_password.error_message');
        } finally {
          this.isLoading = false;
        }
      }
    },
    openLogin() {
      this.$refs.restoreModal.close();
      this.$emit('open-login');
    },
    resetMessages() {
      this.error = null;
      this.infoMessage = null;
    }
  }
}
</script>

<style scoped>
.error {
  border: 1px solid var(--bs-danger);
  background: #ffd4d4;
  border-radius: 4px;
  color: var(--bs-danger);
}
.info-message {
  background: #d4edda;
  border: 1px solid #c3e6cb;
  border-radius: 4px;
  color: #155724;
}
</style>
